import { useQuery } from 'react-query';
import axios from 'axios';
import { CompanyBrand } from '../models/companyBrand';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

const CACHE_KEY = 'basix-brand-chrome-cache';

// item 857 — the APP-CHROME brand read (settings/BrandChrome): name/logo/colors/font/slogan,
// readable by ANY authenticated tenant user. The Outside Sales portal (855) is forced into the
// company brand, but its role is denied SETTINGS_VIEW so the full settings/Brand read 403'd and
// the shell fell back to stock Basix green. Cached locally so the portal boots into the company
// look instead of flashing stock while the request is in flight (mirrors useCompanyBrand).
const readCache = (): CompanyBrand | undefined => {
  try {
    const raw = window.localStorage.getItem(CACHE_KEY);
    return raw ? (JSON.parse(raw) as CompanyBrand) : undefined;
  } catch {
    return undefined;
  }
};

const useBrandChrome = () => {
  const query = useQuery(
    'brandChrome',
    async () => {
      const { data } = await axios.get(`${apiUrl}settings/BrandChrome`);
      return data as CompanyBrand;
    },
    {
      initialData: readCache,
      // item 860 — the localStorage cache is a PAINT hint, not truth: without this,
      // initialData counts as fresh (staleTime 30s, no focus refetch) and a session
      // could keep a stale logo forever after Chad updates the brand in Settings.
      initialDataUpdatedAt: 0,
      onSuccess: (data) => {
        try {
          window.localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        } catch {
          // storage full/blocked — just skip the cache
        }
      },
    },
  );

  return { ...query, brand: query.data };
};

export default useBrandChrome;
